import React, { useState, useRef, useCallback, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { MapContainer, TileLayer, Circle, useMapEvents } from 'react-leaflet'

// Usage:
//
// with hidden field
// add the `input` attr and reference the id of the text field.
//
// <input hidden="true" id="my_location" />
// <react-geo-location input="my_location"></react-geo-location>
//

const LocationMarker = ({ position, onSet }) => {
  const [pinSize, setPinSize] = useState(65)
  const purpleOptions = { color: 'purple' }
  useMapEvents({
    click ({ latlng }) {
      onSet([latlng.lat, latlng.lng])
    },
    zoomend ({ target }) {
      const z = target.getZoom()
      const size = -0.3 * (z ** 2) + 115
      setPinSize(size)
    }
  })

  // TODO: The pin wasn't working. Using the Circle for now.
  return (
    <Circle center={position} pathOptions={purpleOptions} radius={pinSize} />
  )
}

const Component = ({ input }) => {
  const inputRef = useRef(document.getElementById(input))
  const isInteractive = inputRef.current.getAttribute('interactive') === 'true' || inputRef.current.hasAttribute('interactive')

  const [location, setLocation] = useState(null)

  useEffect(() => {
    try {
      setLocation(JSON.parse(inputRef.current.value))
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(e)
      setLocation([48.4255413, -123.3729746])
    }
  }, [inputRef])

  const onSetGeoLocation = useCallback((position) => {
    if (isInteractive) {
      inputRef.current.value = JSON.stringify(position)
      setLocation(position)
    }
  }, [setLocation, isInteractive])

  if (!location) return null

  return (
    <MapContainer style={{ border: '1px solid #111', height: 400 }} center={location} zoom={13} scrollWheelZoom={false}>
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      <LocationMarker position={location} onSet={onSetGeoLocation} />
    </MapContainer>
  )
}

const Init = () => {
  // the main markdown tag for the editor
  const mapLocations = [...document.getElementsByTagName('react-geo-location')]

  if (mapLocations.length > 0) {
    mapLocations.forEach((el) => {
      el.style.display = 'block'

      // get the input id
      const inputId = el.getAttribute('input')
      if (inputId) {
        // check if the id exists
      }

      // get the input by the id
      const input = document.getElementById(inputId)
      if (input) {
        // do something with the input and update it on change
      }

      ReactDOM.render(<Component input={inputId} />, el)
    })
  }
}

document.addEventListener('turbo:load', Init)
